export enum PricingActions {
    TOGGLE_PRICING_PANEL = "togglePricingPanel",
    SET_SELECTED_PRICE = "setSelectedPrice",
    SET_ACTIVE_PRICE_TYPE = "setActivePriceType",
    TOGGLE_PRICING_EDIT = "togglePricingEdit",
}